export default __webpack_public_path__ + "static/media/online-pn-all-banner-graphics.a9a276a2.svg";